module.exports = __webpack_public_path__ + "img/rate-2.ddb81d18.png";